import { render, staticRenderFns } from "./WizardBase.vue?vue&type=template&id=16cf3235&scoped=true&"
import script from "./WizardBase.vue?vue&type=script&lang=js&"
export * from "./WizardBase.vue?vue&type=script&lang=js&"
import style0 from "./WizardBase.vue?vue&type=style&index=0&id=16cf3235&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16cf3235",
  null
  
)

export default component.exports